
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center pt-16 md:pt-20 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(107, 124, 89, 0.1), rgba(107, 124, 89, 0.2)), url('https://static.readdy.ai/image/79237683e9ba10f5e0240023cd0edfec/af3e2fc9a2dd50cc2f9da1a31d14dda8.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundAttachment: 'scroll'
      }}
    >
      <div className="container mx-auto px-4 lg:px-8 py-8 md:py-16">
        <div className="max-w-2xl md:max-w-3xl">
          <div className="bg-white/40 backdrop-blur-md p-5 md:p-10 lg:p-12 rounded-2xl md:rounded-3xl shadow-2xl border border-white/30">
            <h1 
              className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-light text-[#2C3E2D] mb-4 md:mb-6 leading-[1.15] tracking-tight"
              style={{ fontFamily: '"Cormorant Garamond", serif' }}
            >
              Votre <span className="font-medium italic">conciergerie</span> de confiance dans les <span className="font-medium">Pyrénées-Orientales</span>
            </h1>
            <p 
              className="text-xs md:text-sm lg:text-base text-[#4A5240] mb-5 md:mb-7 leading-relaxed font-light max-w-2xl"
              style={{ fontFamily: '"Montserrat", sans-serif' }}
            >
              Nous prenons soin de votre résidence secondaire et optimisons vos <span className="font-normal">locations saisonnières à Perpignan</span> et dans tout le département 66. Confiez-nous votre bien en toute sérénité.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <button 
                onClick={scrollToContact}
                className="px-5 md:px-7 py-2.5 md:py-3.5 bg-[#6B7C59] text-white rounded-xl hover:bg-[#5A6B49] transition-all duration-300 shadow-lg hover:shadow-xl font-normal text-xs md:text-sm whitespace-nowrap cursor-pointer tracking-wide"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                Demandez votre devis gratuit
              </button>
              <button 
                onClick={scrollToContact}
                className="px-5 md:px-7 py-2.5 md:py-3.5 bg-white/95 text-[#6B7C59] border border-[#6B7C59]/30 rounded-xl hover:bg-[#6B7C59] hover:text-white transition-all duration-300 font-normal text-xs md:text-sm whitespace-nowrap cursor-pointer tracking-wide backdrop-blur-sm"
                style={{ fontFamily: '"Montserrat", sans-serif' }}
              >
                Nous contacter
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
